import { Component, OnDestroy, OnInit } from '@angular/core';
import { ThemeService } from '../../core/theme/theme.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent  implements OnInit, OnDestroy {
/** Sidebar visible (mobile drawer / desktop rail). */
  sidebarOpen = false;
  /** Desktop: false = icon rail (72px), true = labels + menus (240px). */
  sidebarExpanded = false;

  constructor(private themeService: ThemeService) {
    // Ensure theme tokens apply as soon as authenticated shell loads
    void this.themeService.mode;
  }

  ngOnInit(): void {
    document.body.classList.add('app-shell-active');
    if (typeof window !== 'undefined' && window.innerWidth >= 992) {
      this.sidebarOpen = true;
      this.sidebarExpanded = false;
    }
  }

   ngOnDestroy(): void {
    document.body.classList.remove('shell-sidebar-open');
    document.body.classList.remove('app-shell-active');
  }

  toggleSidebar(): void {
    if (typeof window !== 'undefined' && window.innerWidth < 992) {
      this.sidebarOpen = !this.sidebarOpen;
      this.sidebarExpanded = this.sidebarOpen;
      document.body.classList.toggle('shell-sidebar-open', this.sidebarOpen);
      return;
    }

    // Desktop: keep rail visible; expand/collapse labels
    this.sidebarOpen = true;
    this.sidebarExpanded = !this.sidebarExpanded;
    document.body.classList.remove('shell-sidebar-open');
  }

  expandSidebar(): void {
    if (typeof window !== 'undefined' && window.innerWidth >= 992) {
      this.sidebarOpen = true;
      this.sidebarExpanded = true;
    }
  }

  closeSidebarMobile(): void {
    if (typeof window !== 'undefined' && window.innerWidth < 992) {
      this.sidebarOpen = false;
      this.sidebarExpanded = false;
      document.body.classList.remove('shell-sidebar-open');
    }
  }
}
